import { FunctionComponent } from 'react';
import { useSelector } from '@cbridge-utils/react-redux';
import { DefaultDataGrid } from '@cbridge-tools/default-data-grid';
import { IAlertSubscription } from '@cbridge-packages/alert';
import { UserSettingsPage } from '@cbridge-packages/user-settings';
import { useAlertSettingsGridColDef } from '../../_hooks/useAlertSettingsGridColDef';
import { alertSettingsDataGridSelector } from './AlertSettingsDataGrid.selector';

const getRowIdFn = (row: IAlertSubscription) => row.type;

export const AlertSettingsDataGrid: FunctionComponent = () => {
  const { subscriptions, isLoading } = useSelector(alertSettingsDataGridSelector);

  const columns = useAlertSettingsGridColDef();

  return (
    <DefaultDataGrid
      settingsKey={UserSettingsPage.ConfigSettingsAlerts}
      disableRowSelectionOnClick={true}
      getRowId={getRowIdFn}
      rows={subscriptions || []}
      columns={columns}
      loading={isLoading}
      initialState={{ sorting: { sortModel: [{ field: 'type', sort: 'asc' }] } }}
      slotProps={{ root: { 'data-testid': 'alert-settings-data-grid' } }}
    />
  );
};
